import { useEffect } from 'react';
import Navigation from '../../components/base/Navigation';
import Footer from '../../components/base/Footer';
import CookieBanner from '../../components/base/CookieBanner';
import WhatsAppButton from '../../components/base/WhatsAppButton';

const CookiesPage = () => {
  useEffect(() => {
    document.title = 'Política de Cookies - Altta Talent Studio';
  }, []);

  return (
    <div className="min-h-screen bg-[#f7f3f0]">
      <Navigation />
      <main className="pt-20">
        <section className="py-20">
          <div className="container-custom section-padding">
            <div className="max-w-4xl mx-auto bg-white p-8 lg:p-12 rounded-sm shadow-lg">
              <h1 className="text-4xl museo-font text-[#3a3a3a] mb-8 font-medium">
                Política de Cookies
              </h1>
              
              <div className="prose max-w-none text-[#3a3a3a]/90 leading-relaxed space-y-6">
                <h2 className="text-2xl museo-font text-[#3a3a3a] font-medium">
                  ¿Qué son las Cookies?
                </h2>
                <p>
                  Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita 
                  un sitio web. Permiten que el sitio web recuerde sus acciones y preferencias durante un 
                  período de tiempo, por lo que no tiene que volver a configurarlas cada vez que regrese 
                  al sitio o navegue de una página a otra.
                </p>

                <h2 className="text-2xl museo-font text-[#3a3a3a] font-medium">
                  ¿Cómo Utilizamos las Cookies?
                </h2>
                <p>
                  Utilizamos cookies para:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Mejorar la funcionalidad y rendimiento del sitio web</li>
                  <li>Analizar cómo los usuarios utilizan nuestro sitio web</li>
                  <li>Personalizar su experiencia de navegación</li>
                  <li>Recordar sus preferencias y configuraciones</li>
                </ul>

                <h2 className="text-2xl museo-font text-[#3a3a3a] font-medium">
                  Tipos de Cookies que Utilizamos
                </h2>

                <h3 className="text-xl museo-font text-[#3a3a3a] font-medium">
                  Cookies Necesarias
                </h3>
                <p>
                  Estas cookies son esenciales para que el sitio web funcione correctamente. Sin estas cookies, 
                  los servicios que ha solicitado no se pueden proporcionar. Estas cookies no almacenan información 
                  personal identificable.
                </p>

                <h3 className="text-xl museo-font text-[#3a3a3a] font-medium">
                  Cookies Analíticas
                </h3>
                <p>
                  Estas cookies nos ayudan a entender cómo los visitantes interactúan con el sitio web, 
                  proporcionándonos información sobre las áreas visitadas, el tiempo de visita en el sitio web 
                  y cualquier problema encontrado, como mensajes de error.
                </p>

                <h3 className="text-xl museo-font text-[#3a3a3a] font-medium">
                  Cookies de Marketing
                </h3>
                <p>
                  Estas cookies se utilizan para mostrar anuncios que son relevantes para usted. También pueden 
                  ser utilizadas para limitar el número de veces que ve un anuncio, así como ayudar a medir 
                  la efectividad de las campañas publicitarias.
                </p>

                <h2 className="text-2xl museo-font text-[#3a3a3a] font-medium">
                  Gestión de Cookies
                </h2>
                <p>
                  Puede controlar y/o eliminar las cookies como desee. Puede eliminar todas las cookies 
                  que ya están en su dispositivo y puede configurar la mayoría de los navegadores para 
                  evitar que se coloquen cookies.
                </p>

                <h3 className="text-xl museo-font text-[#3a3a3a] font-medium">
                  Cómo Deshabilitar las Cookies
                </h3>
                <p>
                  La mayoría de los navegadores web permiten cierto control de la mayoría de las cookies 
                  a través de la configuración del navegador. Para obtener más información sobre las cookies, 
                  incluido cómo ver qué cookies se han configurado y cómo administrarlas y eliminarlas, 
                  visite www.aboutcookies.org o www.allaboutcookies.org.
                </p>

                <h2 className="text-2xl museo-font text-[#3a3a3a] font-medium">
                  Cambios en esta Política
                </h2>
                <p>
                  Podemos actualizar esta política de cookies de vez en cuando para reflejar, por ejemplo, 
                  cambios en las cookies que utilizamos o por otras razones operativas, legales o reglamentarias.
                </p>

                <h2 className="text-2xl museo-font text-[#3a3a3a] font-medium">
                  Contacto
                </h2>
                <p>
                  Si tiene alguna pregunta sobre nuestra política de cookies, no dude en contactarnos en: 
                  contacto@alttatalentstudio.com
                </p>

                <p className="text-sm text-[#3a3a3a]/70 mt-8">
                  Última actualización: {new Date().toLocaleDateString('es-ES')}
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <CookieBanner />
      <WhatsAppButton />
    </div>
  );
};

export default CookiesPage;